import { atom } from "jotai";
import { Deduction } from "@/core/entities/deduction";
import { IUpdateDeductionDetailsRepositoryParams, IUpdateDeductionIntelligenceRepositoryParams } from "@/core/repositories/deduction";

export enum DeductionEditMode {
  DETAILS = "details",
  INTELLIGENCE = "intelligence",
}

interface DeductionState {
  remittanceItemId: number | null;
  deductions: Deduction[];
  count: number;
  isLoading: boolean;
  error: Error | null;
  isIntelligenceUpdating: boolean;
  isApprovalSending: boolean;
  isDetailsUpdating: boolean;
  isChargeBreakdownUpdating: boolean;
  updateDeductionDetails: IUpdateDeductionDetailsRepositoryParams | null;
  updateDeductionIntelligence: IUpdateDeductionIntelligenceRepositoryParams | null;
  updateError: Error | null;
  editMode: DeductionEditMode | null;
}

const initialState: DeductionState = {
  remittanceItemId: null,
  deductions: [],
  count: 0,
  isLoading: false,
  error: null,
  isIntelligenceUpdating: false,
  isApprovalSending: false,
  isDetailsUpdating: false,
  isChargeBreakdownUpdating: false,
  updateDeductionDetails: null,
  updateDeductionIntelligence: null,
  updateError: null,
  editMode: null,
};

export const deductionAtom = atom<DeductionState>(initialState);

export const deductionsAtom = atom(get => get(deductionAtom).deductions);
export const remittanceItemIdAtom = atom(get => get(deductionAtom).remittanceItemId);
export const countAtom = atom(get => get(deductionAtom).count);
export const isLoadingAtom = atom(get => get(deductionAtom).isLoading);
export const errorAtom = atom(get => get(deductionAtom).error);
export const isIntelligenceUpdatingAtom = atom(get => get(deductionAtom).isIntelligenceUpdating);
export const isDetailsUpdatingAtom = atom(get => get(deductionAtom).isDetailsUpdating);
export const isChargeBreakdownUpdatingAtom = atom(get => get(deductionAtom).isChargeBreakdownUpdating);
export const updateDeductionDetailsAtom = atom(get => get(deductionAtom).updateDeductionDetails);
export const updateDeductionIntelligenceAtom = atom(get => get(deductionAtom).updateDeductionIntelligence);
export const updateErrorAtom = atom(get => get(deductionAtom).updateError);
export const editModeAtom = atom(get => get(deductionAtom).editMode);
export const isApprovalSendingAtom = atom(get => get(deductionAtom).isApprovalSending);
